module.exports = __webpack_public_path__ + "img/critical.625d9bba.svg";